module.exports = __webpack_public_path__ + "assets/certificate_pdf/Adobe Photoshop CC_Silicon Stone Education_20170222.7ee217eb.pdf";